import { useTranslations } from 'next-intl';
import { getMentiAcademyURL } from '@mentimeter/user';
import type { MenuAction } from '../types';

export const useMenuActions = (): MenuAction[] => {
  const t = useTranslations('common');

  return [
    {
      name: t('page_links.business'),
      href: '/work',
      referenceId: 'work',
      subActions: [
        {
          name: t('page_links.learning_and_development'),
          href: '/work/learning-and-development',
        },
        {
          name: t('page_links.employee_training'),
          href: '/work/training-and-onboarding',
        },
        {
          name: t('page_links.team_meetings'),
          href: '/work/team-meetings',
        },
        {
          name: t('page_links.workshops'),
          href: '/work/workshops',
        },
        {
          name: t('page_links.all_hands_meetings'),
          href: '/work/all-hands-meetings',
        },
      ],
    },
    {
      name: t('page_links.education'),
      href: '/education',
      referenceId: 'education',
      subActions: [
        {
          name: t('page_links.lectures'),
          href: '/education/lectures',
        },
        {
          name: t('page_links.assessments'),
          href: '/education/assessments',
        },
        {
          name: t('page_links.seminars'),
          href: '/education/seminars',
        },
        {
          name: t('page_links.classroom_lessons'),
          href: '/education/classroom-lessons',
        },
        {
          name: t('page_links.hybrid_learning'),
          href: '/education/hybrid-learning',
        },
      ],
    },
    {
      name: t('page_links.enterprise'),

      referenceId: 'enterprise-grade',
      subActions: [
        {
          name: t('page_links.enterprise'),
          href: '/enterprise',
        },
        {
          name: t('page_links.education'),
          href: '/education/enterprise',
        },

        {
          name: t('page_links.customer_stories'),
          href: '/stories',
        },
        {
          name: t('page_links.trust_center'),
          href: '/trust',
        },
      ],
    },
    {
      name: t('page_links.learn'),
      referenceId: 'learn',
      subActions: [
        {
          name: t('page_links.features_overview'),
          subActions: [
            {
              name: t('page_links.ai_builder'),
              href: '/features/ai-builder',
            },
            {
              name: t('page_links.live_polling'),
              href: '/features/live-polling',
            },
            {
              name: t('page_links.word_cloud'),
              href: '/features/word-cloud',
            },
            {
              name: t('page_links.quiz'),
              href: '/features/quiz-presentations',
            },
            {
              name: t('page_links.surveys'),
              href: '/features/surveys',
            },
            {
              name: t('page_links.presentation_maker'),
              href: '/features/presentation-maker',
            },
            {
              name: t('page_links.q&a'),
              href: '/features/live-questions-and-answers',
            },
          ],
        },
        {
          name: t('page_links.learning_hub'),
          subActions: [
            {
              name: t('page_links.how_to'),
              href: '/how-to',
            },
            {
              name: t('page_links.menti_academy'),
              href: getMentiAcademyURL(
                '?utm_source=mentimeter.com&utm_medium=referral&utm_campaign=top+navigation',
              ),
              target: '_blank',
              prefetch: false,
              rel: 'noopener noreferrer',
            },
            {
              name: t('page_links.templates'),
              href: '/templates',
            },
            {
              name: t('page_links.webinars'),
              href: '/webinars',
            },
            {
              name: t('page_links.blog'),
              href: '/blog',
            },
            {
              name: t('page_links.integrations'),
              href: '/integrations',
            },
            {
              name: t('page_links.help_center'),
              href: 'https://help.mentimeter.com',
              prefetch: false,
            },
          ],
        },
      ],
    },
    { name: t('page_links.pricing'), href: '/plans' },
    {
      name: t('page_links.get_enterprise'),
      href: '/enterprise',
    },
  ];
};
